import React from 'react';
import { motion } from 'framer-motion';
import SkillBar from './SkillBar';
import { Skill } from '../../types';

interface SkillCategoryProps {
  categoryId: string;
  categoryName: string;
  icon: string;
  skills: Skill[];
  onSkillClick: (skill: Skill) => void;
}

const SkillCategory: React.FC<SkillCategoryProps> = ({
  categoryName,
  icon,
  skills,
  onSkillClick,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="bg-white dark:bg-gray-800 rounded-2xl p-6 border border-gray-200 dark:border-gray-700 shadow-sm hover:shadow-md transition-shadow"
    >
      {/* Header categoria con icona */}
      <div className="flex items-center gap-3 mb-6">
        <span className="text-2xl">{icon}</span>
        <h3 className="text-xl font-bold text-gray-900 dark:text-white">
          {categoryName}
        </h3>
      </div>

      {/* Lista skill della categoria */}
      <div className="space-y-4">
        {skills.map((skill) => (
          <SkillBar
            key={skill.id}
            skill={skill}
            onClick={() => onSkillClick(skill)}
          />
        ))}
      </div>
    </motion.div>
  );
};

export default SkillCategory;
